import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { adminMe, adminLogin, adminLogout } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const { pathname } = useLocation();
  const [admin, setAdmin] = useState(null); // null = checking, false = not auth, object = auth

  const needsAdminCheck = pathname === "/admin" || pathname === "/admin/login" || pathname.startsWith("/admin/");

  const check = useCallback(async () => {
    try {
      const data = await adminMe();
      setAdmin(data);
    } catch (e) {
      setAdmin(false);
    }
  }, []);

  useEffect(() => {
    if (needsAdminCheck) check();
    else setAdmin(false);
  }, [check, needsAdminCheck]);

  const login = useCallback(async (email, password) => {
    const data = await adminLogin(email, password);
    setAdmin(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await adminLogout();
    } catch (e) {}
    setAdmin(false);
  }, []);

  return (
    <AuthContext.Provider value={{ admin, login, logout, check }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
